import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactPlayer from "react-player";

const VideoModal = ({ showModal, handleClose, videoUrl, Title, id }) => {
  const [playCounts, setPlayCounts] = useState({});

  const handleVideoPlay = (videoId) => {
    setPlayCounts((prevCounts) => ({
      ...prevCounts,
      [videoId]: (prevCounts[videoId] || 0) + 1,
    }));
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReactPlayer
          url={`https://api.taab30.com${videoUrl}`}
          controls
          width="100%"
          height="100%"
          playing={true}
          playsinline
          onPlay={() => handleVideoPlay(id)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary btn-danger" onClick={handleClose}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VideoModal;
